import React from 'react';
import { ShowIf } from 'components/utils';
import { Input } from 'components/tt-forms/common';

class InputList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      value: '',
      indexConfirm: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.convertValueToData(nextProps.data)
    }
  }

  componentDidMount() {
    this.convertValueToData(this.props.data);
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleConfirm(data) {
    if(this.props.handleConfirm(data)) {
      //do nothing
    } else {
      this.removeDonViConfirm();
    }
  }

  convertValueToData(data) {
    let dataResult = [];
    let newCheck = data;
    if (newCheck) {
      let newData = newCheck.split('; ');
      newData.map(state => {
        dataResult[dataResult.length] = {
          ten: state
        }
      })
      this.setState({
        data: [...dataResult]
      })
    } else {
      this.setState({
        data: []
      })
    }
  }

  convertDataToValue() {
    let e = {
      target: {
        value: '',
        count: this.state.data.length
      }
    }
    this.state.data.map((state, i) => {
      if (i == 0) {
        e.target.value = e.target.value + state.ten
      } else {
        e.target.value = e.target.value + '; ' + state.ten
      }
    })
    this.props.onChange(e);
  }

  onChange(name,e) {
    this.setState({
      [name]: e.target.value
    })
  }

  addDonVi(e) {
    if (typeof e != 'undefined') {
      e.preventDefault();
    }
    let newArr = [...this.state.data];

    let arrCheck = newArr.filter(state => {
      return state.ten == this.state.value
    })

    if (this.state.value.trim()) {
      if (arrCheck.length > 0) {
        this.setState({
          value: ''
        })
      } else {
        let newItem = {
          ten: this.state.value
        }
        this.setState({
          data: [
            ...this.state.data,
            newItem
          ],
          value: ''
        }, () => {
          this.convertDataToValue()
        })
      }
    } else {
      this.setState({
        value: ''
      })
    }
    return;
  }

  removeDonVi(index) {
    if(this.props.confirm) {
      this.setState({
        indexConfirm: index
      }, () => {
        this.handleConfirm(this.state.data[index]);
      })
    } else {
      let newData = [...this.state.data];
      newData.splice(index, 1);
      this.setState({
        data: newData
      }, () => {
        this.convertDataToValue()
      })
    }

  }

  removeDonViConfirm() {
    let newData = [...this.state.data];
    newData.splice(this.state.indexConfirm, 1);
    this.setState({
      data: newData
    }, () => {
      this.convertDataToValue()
    })
  }

  render() {
    return (
      <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this)}>
        <div className='wrap-input-tt-dvph col-25'>
          <Input label={this.props.label} name={this.props.name} placeholder='Nhập...' className='col-100 no-gutter' value={this.state.value} onChange={this.onChange.bind(this, 'value')} maxLength={1000} />
          <button className='btn-add-dvph' name={this.props.name} type='submit'></button>
        </div>
        <ShowIf condition={!this.props.hasCount}>
          <div className='col-75 mb18'>
            <div className='ds-tt-dvph'>
              {
                this.state.data.map((item,i) => {
                  return (
                    <div className='tt-dvph-item' key={i}>
                      <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this,i)}>×</span>
                      <span className="tt-dvph-value">{item.ten}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.hasCount}>
          <div className='col-60 mb18'>
            <div className='ds-tt-dvph'>
              {
                this.state.data.map((item,i) => {
                  return (
                    <div className='tt-dvph-item' key={i}>
                      <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this,i)}>×</span>
                      <span className="tt-dvph-value">{item.ten}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='col-15 mb18 count-dv'>
            Tổng: {this.state.data.length}&nbsp;{this.props.countUnit}
          </div>
        </ShowIf>
      </form>
    );
  }
}

InputList.defaultProps = {
  data: '',
  label: 'This is label',
  hasCount: false,
  confirm: false,
  onRef: function() {
  },
  countUnit: 'đơn vị',
  onChange: function() {
    console.log('Need to assign onChange method');
  }
}

export default InputList;


// WEBPACK FOOTER //
// ./src/components/tt-forms/common/InputList.jsx